import axios from "axios";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

/**
 * postContentReport
 *
 * Send content report.
 *
 * @param content_type Name of the content type.
 * @param content_url URL of content.
 * @param message contents of report.
 * @param content_name Name of the content.
 * @returns Result of sending content report.
 */

export const postContentReport = async (
  content_type: string,
  content_url: string,
  message: string,
  content_name?: string
) => {
  try {
    const res = await axios.post(getAPIRoot(APIRoutes.post.content_report), {
      sonic_content_type: content_type,
      sonic_content_name: content_name,
      sonic_content_url: content_url,
      sonic_message: message,
    });

    return res.data.result;
  } catch (e) {
    return false;
  }
};
